<template>
  <el-date-picker
    v-model="value"
    :class="`${bem.b()} ${prepareClassNames()}`"
    :style="{
      ...prepareStyles(),
    }"
    v-bind="customAttrs"
  />
</template>
<script setup lang="ts">
import { computed, useSlots, watch, ref, onMounted } from 'vue'
import { createNameSpace } from '@el-plus/utils/bem'
import { datePickerRangeProps, datePickerRangeEmits } from './date-picker-range'
import type {
  DatePickerRangeProps,
  DatePickerRangeEmits,
} from './date-picker-range'
import {
  prepareProps,
  prepareEvents,
  prepareClassNames,
  prepareStyles,
} from '@el-plus/utils/props'

defineOptions({
  name: 'EpDatePickerRange',
  inheritAttrs: false,
})
const bem = createNameSpace('datePickerRange')
const props = defineProps(datePickerRangeProps)
const emit = defineEmits(datePickerRangeEmits)
const slots = computed(() => {
  return Object.keys(useSlots())
})
const value = defineModel<DatePickerRangeProps['modelValue']>()
const start = defineModel<DatePickerRangeProps['modelValue']>('start')
const end = defineModel<DatePickerRangeProps['modelValue']>('end')
watch(
  value,
  (newValue) => {
    if (props.type === 'daterange') {
      if (newValue && newValue[1]) {
        const endDate = new Date(newValue[1])
        newValue[1] = endDate.setHours(23, 59, 59, 0)
      }
      start.value = newValue ? newValue[0] : ''
      end.value = newValue ? newValue[1] : ''
    }
  },
  {
    immediate: true,
  },
)
const customAttrs = computed(() => {
  return {
    ...prepareProps(props, ['modelValue']),
    // ...prepareEvents<InputEmits>(emit, inputEmitsKeys),
  }
})
</script>
